import { GetUserVideo, getVideo } from '../s3Func/s3Download';

export const replaceCredentials = (link, studentID, influencerId) => {
  return link
    .replace(/{student-id.*?}/g, studentID)
    .replace(/{influencer-id.*?}/g, influencerId);
};

// Set a timer for ms milliseconds.
export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// Loads use content and replace credentials
export const getUserContent = async (link, studentID, influencerId, login) => {
  const url = replaceCredentials(link, studentID, influencerId);
  return GetUserVideo(url, login);
};

export const getSlideImages = async (photos, module, login) => {
  if (photos && photos.length > 0) {
    let slides = photos;

    if (module.currentday < 4) {
      return Promise.all(photos.map(async (url) => await getVideo(url, login)));
    }

    slides = photos.map((link) =>
      replaceCredentials(link, module.StudentID, login.influencerid)
    );
    return Promise.all(slides.map(async (url) => await GetUserVideo(url, login)));
  }
  return null;
};
